<div class="w-full">
  <div class="flex items-center justify-between mb-2">
    <div class="text-sm font-medium text-gray-700">Regionen</div>
    <div class="flex gap-2">
      <button
        type="button"
        mat-stroked-button
        (click)="selectAll()"
        class="text-xs"
      >
        Alle auswählen
      </button>
      <button
        type="button"
        mat-stroked-button
        (click)="clearAll()"
        class="text-xs"
      >
        Alle entfernen
      </button>
    </div>
  </div>

  <mat-accordion [multi]="true" class="border rounded-md divide-y">
    @for (state of states; track state) {
      <mat-expansion-panel [expanded]="isStateIndeterminate(state)">
        <mat-expansion-panel-header>
          <div class="flex items-center w-full py-1">
            <mat-checkbox
              [checked]="isStateChecked(state)"
              [indeterminate]="isStateIndeterminate(state)"
              (change)="toggleState(state)"
              >{{ state.name }}</mat-checkbox
            >
          </div>
        </mat-expansion-panel-header>

        <div class="grid grid-cols-1 md:grid-cols-2 gap-2 mt-2 pl-6 pb-3">
          @for (district of state.bezirke; track district) {
            <mat-checkbox
              [checked]="isDistrictChecked(district)"
              (change)="toggleDistrict(district)"
              >{{ district.name }}</mat-checkbox
            >
          }
        </div>
      </mat-expansion-panel>
    }
  </mat-accordion>
</div>
